
<div class="flow-env-action" :disabled="disabled" :state="state" @click="handleClick($event)">
	<div
		class="flow-env-action-info"
		:nofooter="$slots['footer'] ? false : true"
		:disabled="disableInfo"
		@click="contentClick($event)"
	>
		<slot />
	</div>
	<div
		v-if="$slots['footer']"
		class="flow-env-action-footer flex-gap-8"
		:disabled="disableFooter"
		@click="footerClick($event)"
	>
		<slot name="footer" />
	</div>
	<div v-if="$slots['meta']" class="flow-env-action-meta-icons">
		<slot name="meta" />
	</div>
</div>
